// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@vanmeter/App/Components/Notify";
import { headerStyles } from "@vanmeter/Overrides/Widgets/OrderApprovalDetails/OrderApprovalDetailsHeader";
import { css } from "styled-components";

headerStyles.buttonGridItem = {
    width: 12,
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 16px 24px;
        justify-content: flex-end;
        @media print {
            display: none;
        }
    `,
};
headerStyles.titleGridItem = {
    width: 12,
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

headerStyles.headerGridContainer = {
    gap: 0,
};

headerStyles.title = {
    variant: "h1",
    as: "h1",
};

headerStyles.messageWrapper = {
    css: css`
        margin-top: 12px;
    `,
};

headerStyles.messageText = {
    ...getNotifyStyle("info", true),
};
